import { get } from 'lodash';

function getInsuranceValuesForValidation(validationCallBack, index) {
  return (value, message, args, values) => (validationCallBack({ values: get(values, 'insurance', {})[index], value }));
}

export default getInsuranceValuesForValidation;
